<template>
    <Card>
        <CalendarIcon :date="meeting.start" size="xl"></CalendarIcon>
        <NuxtLink :to="`/${route.params.site_slug}/meetings/${meeting.slug}`">
            <Heading4 class="mt-6">{{ meeting.title }}</Heading4>
        </NuxtLink>
        <ClientOnly>
            <div class="text-gray-700 mt-0.5 mb-1.5">
                {{ fullDate(meeting.start) }}
            </div>
            <template #fallback>
                <div class="text-gray-700 mt-0.5 mb-1.5">&nbsp;</div>
            </template>
        </ClientOnly>
        <div class="mt-6" v-if="meeting.materials_published">
            <Button :to="`/${route.params.site_slug}/meetings/${meeting.slug}`">
                View agenda & details
            </Button>
        </div>
    </Card>
</template>

<script setup>
import Button from "~/components/public/Button.vue";
import CalendarIcon from "~/components/public/CalendarIcon.vue";
import Card from "~/components/public/Card.vue";
import Heading4 from "~/components/public/Heading4.vue";

const route = useRoute();

const { meeting } = defineProps({
    meeting: {
        type: Object,
        required: true
    }
});

const { stripHtml } = useHtmlUtils();
const { fullDate } = useDateUtils();
</script>